export class RefreshTokenUpdateError extends Error {
  static msg = 'can not update refresh token';

  constructor() {
    super(RefreshTokenUpdateError.msg);
  }
}
